export const AUTH_TOKEN = 'AUTHENTICATION_TOKEN_V2';
export const USER_ID = 'AUTHENTICATION_USER_ID';
export const IS_IMPERSONATION_SESSION = 'IS_IMPERSONATION_SESSION';
export const COGNITO_SSO_LOGOUT = 'AUTHENTICATION_COGNITO_SSO_LOGOUT';
